// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__10vlZ","item":"PaymentsMobile_item__2_iWQ","label":"PaymentsMobile_label__i_SBB","amount":"PaymentsMobile_amount__3KdyV"};